import { License } from '../../store/license/types';
import { LEGACY_LICENSE_MAPPING } from '../constants/license';

/**
 * Migrate a license from legacy boolean format to new modular format
 */
export const migrateLicenseToModular = (license: License): License => {
  // If already has modular fields, return as-is
  if (license.datasets && license.modules) {
    return license;
  }

  const datasets: string[] = [];
  const modules: string[] = [];

  // Convert boolean flags to modular arrays
  if (license.viewDatabase) {
    datasets.push(...LEGACY_LICENSE_MAPPING.viewDatabase);
  }

  if (license.ccsModule) {
    modules.push(...LEGACY_LICENSE_MAPPING.ccsModule);
  }

  if (license.viewAnalogue) {
    modules.push(...LEGACY_LICENSE_MAPPING.viewAnalogue);
  }

  return {
    ...license,
    datasets,
    modules
  };
};

/**
 * Convert modular license back to legacy boolean format (for backward compatibility)
 */
export const convertModularToLegacy = (license: License): License => {
  if (!license.datasets && !license.modules) {
    return license; // Already in legacy format
  }

  const viewDatabase = license.datasets ? 
    LEGACY_LICENSE_MAPPING.viewDatabase.some(dataset => license.datasets!.includes(dataset)) : 
    false;

  const ccsModule = license.modules ? 
    license.modules.includes('ccs_module') : 
    false;

  const viewAnalogue = license.modules ? 
    license.modules.includes('analogue_finder') : 
    false;

  return {
    ...license,
    viewDatabase,
    ccsModule,
    viewAnalogue
  };
};

/**
 * Ensure license has both legacy and modular fields for full compatibility
 */
export const ensureLicenseCompatibility = (license: License): License => {
  const modular = migrateLicenseToModular(license);
  const legacy = convertModularToLegacy(modular);
  
  return {
    ...license,
    ...legacy,
    datasets: modular.datasets,
    modules: modular.modules
  };
}; 